import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Briefcase, BarChart3, Mail, Sun, Moon, BrainCircuit, Newspaper } from 'lucide-react';
// Certifique-se de que o arquivo Logo.js existe na mesma pasta, ou remova esta linha se não tiver
import { Logo } from './Logo';

const Navbar = ({ darkMode, setDarkMode }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Vagas', href: '/vagas', icon: Briefcase },
    { name: 'Notícias', href: '/noticias', icon: Newspaper }, // Adicionei para não perder a página nova
    { name: 'Estatísticas', href: '/estatisticas', icon: BarChart3 },
    { name: 'Teste DISC', href: '/disc', icon: BrainCircuit },
    { name: 'Contato', href: '/contato', icon: Mail },
  ];

  const isActive = (href) => location.pathname === href;

  return (
    // "print:hidden" garante que o navbar suma na impressão
    <nav className="sticky top-0 z-50 bg-white/80 dark:bg-slate-900/80 backdrop-blur-2xl border-b border-slate-100 dark:border-slate-800 print:hidden">
      <div className="container mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between h-20">
          
          {/* --- LOGO --- */}
          <Link 
            to="/" 
            className="group hover:opacity-90 transition-opacity flex items-center gap-2" 
            onClick={() => setMobileMenuOpen(false)}
          >
            {/* Se você não tiver o arquivo Logo.js, pode apagar a linha abaixo e usar um texto */}
            <Logo theme={darkMode ? 'dark' : 'light'} />
            {/* <span className="font-bold text-xl text-teal-600 dark:text-teal-400">Empregos RO</span> */}
          </Link>

          {/* --- NAVEGAÇÃO DESKTOP --- */}
          <div className="hidden lg:flex items-center gap-2">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2.5 rounded-xl font-medium transition-all duration-300 flex items-center gap-2 text-sm ${
                  isActive(item.href)
                    ? 'text-teal-600 bg-teal-50 dark:bg-teal-900/20 dark:text-teal-400 font-bold shadow-sm'
                    : 'text-slate-600 dark:text-slate-300 hover:text-teal-600 dark:hover:text-teal-400 hover:bg-slate-50 dark:hover:bg-slate-800'
                }`}
              >
                {/* Destaque especial para o ícone do DISC */}
                {item.name === 'Teste DISC' && <BrainCircuit className="w-4 h-4" />}
                {item.name}
              </Link>
            ))}
          </div>

          {/* --- LADO DIREITO (Dark Mode & Mobile Menu) --- */}
          <div className="flex items-center gap-3">
            {/* Botão de Tema */}
            <button
              onClick={() => setDarkMode(!darkMode)}
              className="p-2.5 rounded-xl bg-slate-100 dark:bg-slate-800 hover:bg-slate-200 dark:hover:bg-slate-700 transition-all active:scale-95"
              aria-label="Alternar tema"
            >
              {darkMode ? 
                <Sun className="w-5 h-5 text-amber-400 fill-amber-400" /> : 
                <Moon className="w-5 h-5 text-slate-600 fill-slate-600" />
              }
            </button>
            
             {/* Botão Menu Mobile */}
             <button 
               onClick={() => setMobileMenuOpen(!mobileMenuOpen)} 
               className="lg:hidden p-2.5 rounded-xl hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors active:scale-95"
               aria-label="Menu principal"
             >
               {mobileMenuOpen ? <X className="w-6 h-6 text-slate-800 dark:text-white" /> : <Menu className="w-6 h-6 text-slate-800 dark:text-white" />}
             </button>
          </div>
        </div>
      </div>
      
      {/* --- MENU MOBILE EXPANDIDO --- */}
      <div className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out border-b border-slate-100 dark:border-slate-800 ${mobileMenuOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="bg-white dark:bg-slate-900 p-4 space-y-2 shadow-lg">
            {navigation.map((item) => (
              <Link 
                key={item.name} 
                to={item.href} 
                onClick={() => setMobileMenuOpen(false)} 
                className={`flex items-center gap-4 p-4 rounded-xl font-medium transition-all ${
                  isActive(item.href) 
                    ? 'bg-teal-50 dark:bg-teal-900/20 text-teal-600 dark:text-teal-400 shadow-sm' 
                    : 'hover:bg-slate-50 dark:hover:bg-slate-800 text-slate-700 dark:text-slate-300'
                }`}
              >
                  <div className={`p-2 rounded-lg ${isActive(item.href) ? 'bg-white dark:bg-slate-800' : 'bg-slate-100 dark:bg-slate-800'}`}>
                    <item.icon className={`w-5 h-5 ${isActive(item.href) ? 'text-teal-500' : 'text-slate-500'}`} />
                  </div>
                  <span className="text-lg">{item.name}</span>
              </Link>
            ))}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;